<div class="{{checkActiveState(item.data)}}" [matTooltip]="'general.publish.' + checkActiveState(item.data) | translate"></div>
